<h2 mat-dialog-title>Configurazione Tabella di Compilazione</h2>
<div style="height: 15px"></div>
<div class="cnt-cmp-btn">
  <div style="flex: 1">
    <ng-scrollbar>
      <div style="margin-right: 20px">
        <app-tabella-cfg-dinamica
          #cfgTabella
          [tabella]="data.tabella"
          [disabilitaCelle]="true"
          [isConfigurazione]="data.isConfigurazione"
        ></app-tabella-cfg-dinamica>
      </div>
    </ng-scrollbar>
  </div>

  <!-- Bottone Salva -->
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
